import { render, staticRenderFns } from "./PunchInDetails.vue?vue&type=template&id=dda48778&scoped=true"
import script from "./PunchInDetails.vue?vue&type=script&lang=js"
export * from "./PunchInDetails.vue?vue&type=script&lang=js"
import style0 from "./PunchInDetails.vue?vue&type=style&index=0&id=dda48778&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda48778",
  null
  
)

export default component.exports